import {useSelector} from 'src/v2/state/store';

export const useIsRelayWalletConnectCurrency = (): boolean => {
  const selectedCurrency = useSelector((state) => state.selectedCurrency);
  const walletConnectEnabled = useSelector(
    (state) => state.featureFlags.enable_pay_with_any_crypto_wallet_connect,
  );
  const nonStablesEnabled = useSelector(
    (state) =>
      state.featureFlags.enable_pay_with_any_crypto_wallet_connect_non_stables,
  );

  if (
    !walletConnectEnabled ||
    !selectedCurrency?.paymentOptions.includes('wallet_connect')
  ) {
    return false;
  }

  const {assetCode} = selectedCurrency;
  if (assetCode === 'usdt') return true;
  return nonStablesEnabled && (assetCode === 'eth' || assetCode === 'sol');
};
